import React from 'react'
import styled from 'styled-components'
import PureSelect from '../pure-select.component'
import { connect } from 'react-redux'
import { StyledCardFields } from '../payment-fields/styled-card-fields.style'
import { getMuvicardInstallmentOptions } from '../../../modules/private/client/ticket-sale/muvicard-installment-options'
import { Creators as MuvicardPurchaseCreators } from '../../../ducks/muvicard-purchase/muvicard-purchase'
import MuvicardPurchaseSelectors from '../../../ducks/muvicard-purchase/muvicard-purchase.selectors'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'

const StyledFieldsContainer = styled.div`
	.active-one-click {
		margin-top: 3rem;
		font-weight: bold;
	}
`
class MuvicardOneClick extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isGettingMuvicardInstallmentsOptions: false,
			fetchedMuvicardInstallmentOptions: false,
		}
	}

	componentWillUnmount() {
		this.props.setInstallmentsOptions([])
		this.props.setInstallmentsQtt(1)
	}

	componentDidMount() {
		const { orderValue } = this.props

		if (this.state.fetchedMuvicardInstallmentOptions) {
			return
		}

		this.inputInstallmentOptions(orderValue)
	}

	setInterestValue(installment) {
		this.props.setInterestRate(installment)
	}

	async inputInstallmentOptions(value) {
		try {
			this.setState({ isGettingMuvicardInstallmentsOptions: true })

			let muvicardInstallmentOptions = await getMuvicardInstallmentOptions(
				value
			)

			this.setState({
				isGettingMuvicardInstallmentsOptions: false,
				fetchedMuvicardInstallmentOptions: true,
			})

			if (muvicardInstallmentOptions) {
				this.props.setInstallmentsOptions(muvicardInstallmentOptions)
			}

			if (installmentsQtt) {
				this.setInterestValue(this.props.installmentsQtt)
			}
		} catch (error) {
			this.setState({
				isGettingMuvicardInstallmentsOptions: false,
				fetchedMuvicardInstallmentOptions: false,
			})
		}
	}

	renderMuvicardInstallments = (installmentsOptions) => {
		const { isCalculatingValues } = this.props
		const { isGettingMuvicardInstallmentsOptions } = this.state

		const fetchingInstallmentOptions =
			!installmentsOptions.length ||
			isCalculatingValues ||
			isGettingMuvicardInstallmentsOptions

		let noInstallmentsMessage =
			'Valor de parcela incompatível para compra no cartão Muvicard'

		return (
			<PureSelect
				{...this.props}
				id="installments"
				label="Parcelamento"
				className="installments"
				placeholder={
					fetchingInstallmentOptions ? 'Calculando...' : 'Selecione...'
				}
				options={installmentsOptions}
				handleChange={(e) => {
					const installment = e.target.value

					if (installment) {
						this.props.setInstallmentsQtt(installment)
						this.setInterestValue(installment)
					}

					return this.props.handleChange(e)
				}}
				noOptionsMessage={noInstallmentsMessage}
				disabled={fetchingInstallmentOptions}
			/>
		)
	}

	render() {
		const { installmentsOptions, user } = this.props

		let installments = installmentsOptions

		if (user && user.hasPublicBody) {
			installments = installmentsOptions.slice(0, 1)
		}

		return (
			<React.Fragment>
				<p className="blue">Muvicard 1 clique</p>
				<StyledFieldsContainer>
					<span className="active-one-click">
						Você está com o serviço de compra com 1 clique Muvicard ativo.
						<br />
						Para alterar essa opção, acesse o menu Meus Dados.
					</span>
					<StyledCardFields>
						{this.renderMuvicardInstallments(installments)}
					</StyledCardFields>
				</StyledFieldsContainer>
			</React.Fragment>
		)
	}
}

const mapStateToProps = (store) => ({
	installmentsOptions:
		MuvicardPurchaseSelectors.getMuvicardInstallmentsOptions(
			store.muvicardPurchase
		),
	isCalculatingValues: store.ticketSale.isCalculatingValues,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	installmentsQtt: MuvicardPurchaseSelectors.getMuvicardInstallmentsQtt(
		store.muvicardPurchase
	),
})

const mapDispatchToProps = {
	setInstallmentsQtt: MuvicardPurchaseCreators.setMuvicardInstallmentsQtt,
	setInterestRate: MuvicardPurchaseCreators.setMuvicardInterestRate,
	setInstallmentsOptions:
		MuvicardPurchaseCreators.setMuvicardInstallmentsOptions,
}
export default connect(mapStateToProps, mapDispatchToProps)(MuvicardOneClick)
